import { memo, useMemo } from "react";
import Chip from "@mui/material/Chip";
import { useTheme } from "@mui/material/styles";

import { DISPATCH_ORDER } from "../constants";

const { shortClosureStatus } = DISPATCH_ORDER;

const ShortClosureStatus = ({ label }) => {
  const theme = useTheme();

  const statusStyles = useMemo(() => {
    const { success, warning, error, grey } = theme.palette;
    return {
      [shortClosureStatus.approved]: {
        color: success.dark,
        background: success.main,
      },
      [shortClosureStatus.requistRaised]: {
        color: warning.dark,
        background: warning.main,
      },
      [shortClosureStatus.rejected]: {
        color: error.dark,
        background: error.main,
      },
      [shortClosureStatus.noRequestRaised]: {
        color: grey.dark,
        background: grey.light,
      },
    };
  }, [theme]);

  const style = statusStyles[label] || {};

  return <Chip label={label} sx={style} size="small" />;
};

export default memo(ShortClosureStatus);
